import { createSelector } from "reselect";
import { StatusEnum } from "../utilities/index.js";

const actionRequestList = (state) => state.vendorPendingActionRequests;

export const vendorPendingRequestsSelector = createSelector(
  actionRequestList,
  (actions) => {
    return actions.filter(
      (action) =>
        action.status === StatusEnum.NEEDS_REVIEW.id ||
        action.status === StatusEnum.PROCESSING.id
    );
  }
);
